<template>
  <v-layout row wrap>
    <v-flex xs12 md4>
      <v-card class="elevation-0 shadow my-2 pa-4">
        <h3 class="di-flex justify-space-between align-center">
          <span>{{ $t("closing_balance") }}</span>
          <v-btn
            icon
            flat
            class="ma-0"
            color="grey darken-2"
            :title="$t('capital')"
            @click="hide_old_capital = !hide_old_capital"
          >
            <v-icon>
              {{ hide_old_capital ? "visibility_off" : "visibility" }}
            </v-icon>
          </v-btn>
        </h3>
        <v-divider class="my-2"></v-divider>
        <!-- <template > -->
        <h3
          :key="index"
          v-for="(account, index) in old_items"
          :class="account.color"
          class="di-flex pa-2 subheading font-weight-bold white--text cbg mt-1"
        >
          <span class="mx-3"> {{ account.name }}</span>

          <span dir="ltr">{{ account.balance | currency }}</span>
          <v-spacer></v-spacer>
          <span dir="ltr" class="body-2 mx-2" :title="$t('rate')">{{
            account.rate
          }}</span>
        </h3>

        <!-- <v-divider class="my-1" :key="index+'_2'"></v-divider> -->
        <!-- </template> -->
      </v-card>
    </v-flex>
    <v-flex xs12 md4>
      <v-card class="elevation-0 shadow my-2 pa-4">
        <h3 class="di-flex justify-space-between align-center">
          <span>{{ $t("current_balance") }}</span>
          <v-btn
            icon
            flat
            class="ma-0"
            color="grey darken-2"
            :title="$t('capital')"
            @click="hide_new_capital = !hide_new_capital"
          >
            <v-icon>
              {{ hide_new_capital ? "visibility_off" : "visibility" }}
            </v-icon>
          </v-btn>
        </h3>
        <v-divider class="my-2"></v-divider>
        <!-- <template> -->
        <h3
          v-for="(account, index) in new_items"
          :key="index"
          class="di-flex pa-2 subheading font-weight-bold white--text cbg mt-1"
          :class="account.color"
        >
          <span class="mx-3"> {{ account.name }}</span>

          <span dir="ltr">{{ account.balance | currency }}</span>
          <v-spacer></v-spacer>
          <span dir="ltr" class="body-2 mx-2" :title="$t('rate')">{{
            account.rate
          }}</span>
        </h3>
        <!-- <v-divider class="my-1" :key="index+'_2'"></v-divider> -->
        <!-- </template> -->
      </v-card>
    </v-flex>
    <v-flex xs12 md4>
      <v-card class="elevation-0 shadow my-2 pa-4">
        <h3 class="di-flex justify-space-between align-center">
          <span>{{ $t("exchange_results") }}</span>
        </h3>
        <v-divider class="my-2"></v-divider>
        <template v-for="(account, index) in exposed_items">
          <h3
            :key="index"
            v-if="index != 'total'"
            :class="{
              'red--text': account.exposed_amount < 0,
              'activeColor--text': account.exposed_amount > 0,
            }"
            class="di-flex subheading font-weight-bold grey lighten-3 cbg mt-1"
          >
            <span class="pa-2 white--text" :class="account.color">
              {{ account.name }}</span
            >
            <span dir="ltr" class="py-2 px-3">
              {{ account.exposed_amount | currency }}
            </span>
            <v-spacer />
            <span dir="ltr" class="body-2 pa-2" :title="$t('rate')"> {{ account.rate }}</span>
            <!-- <span dir="ltr" class="py-2 px-3" :class="{
              'red--text': account.exposed_base_amount < 0,
              'activeColor--text': account.exposed_base_amount > 0,
            }">
              {{ account.exposed_base_amount | currency({symbol:smbl(1)}) }}
            </span> -->
          </h3>
          <!-- <v-divider class="my-1" :key="index+'_2'"></v-divider> -->
        </template>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ["accounts_bar", "opening_accounts_bar"],

  data: () => ({
    currencies: [1, 2, 3, 4],
    hide_old_capital: true,
    hide_new_capital: true,
  }),

  computed: {
    old_items() {
      let items = Object.assign({}, this.opening_accounts_bar);
      if (this.hide_old_capital) delete items.total;
      return items;
    },
    new_items() {
      let items = Object.assign({}, this.accounts_bar);
      if (this.hide_new_capital) delete items.total;
      return items;
    },
    exposed_items() {
      let items = Object.assign({}, this.accounts_bar);
      if (this.hide_new_capital) delete items.total;
      items = Object.values(items).sort(
        (a, b) => b.exposed_base_amount - a.exposed_base_amount
      );
      console.log(items);
      return items;
    },
  },
};
</script>
<style >
.cbg {
  background-repeat: no-repeat;
  /* background-image: url("../../assets/images/cardbg.svg") !important; */
  background-size: 100% auto;
  background-origin: content-box;
  /* background-position: 0 center; */
}
</style>